<ion-header mode="ios">
  <ion-toolbar color="secondary">
    <ion-title class="text-grey-ultra-dark">{{ 'pages.fund-cash.purchase.confirm.split.listModal.title' | translate }} </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="confirmSplits()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <front-end-fund-cash-purchase-card
    [cashFund]="cashFund"
    [project]="project"
    [showSplit]="false"
    [amount]="parentAmount"
  ></front-end-fund-cash-purchase-card>

  <div class="flex flex-row justify-content-space-between align-items-center ion-margin-bottom">
    <div class="font-medium block ion-text-uppercase">
      {{ 'pages.fund-cash.purchase.confirm.split.listModal.splitSection' | translate }}
    </div>
    <ion-button fill="clear" color="primary" (click)="openAddSplitModal()" [disabled]="parentAmount <= 0">
      <div class="flex align-items-center gap-2">
        <span>{{ 'pages.fund-cash.purchase.confirm.split.listModal.addSplit' | translate }}</span>
        <ion-icon name="add-circle-outline" color="primary" class="action-icon"></ion-icon>
      </div>
    </ion-button>
  </div>

  <ion-list>
    <ion-card class="split-card ion-margin-bottom" *ngFor="let split of splitRows; let i = index">
      <ion-card-content>
        <div class="item-tags">
          <span>{{ split.article?.description }} ({{ split.subtask?.taskName }}/{{ split.subtask?.name }})</span>
        </div>
        <div class="flex align-items-center justify-content-end">
          <span class="amount">
            <strong>{{ split.amount | currency: 'EUR':'symbol-narrow':'1.2' }}</strong>
          </span>

          <ion-button fill="clear" color="primary" class="delete-btn" (click)="removeSplit(i)">
            <ion-icon name="trash-outline" color="primary" class="action-icon"></ion-icon>
          </ion-button>
        </div>
      </ion-card-content>
    </ion-card>
  </ion-list>
</ion-content>
